module.exports = __webpack_public_path__ + "img/card-title.56282471.png";